module.exports = __webpack_public_path__ + "img/s03_p09.f787ee89.jpg";